/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameActionPlusIcon16Light = forwardRef('ScanFrameActionPlusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 1A2.5 2.5 0 0 1 14 3.5V5a.5.5 0 0 1-1 0V3.5A1.5 1.5 0 0 0 11.5 2H10a.5.5 0 0 1 0-1h1.5Z" }),
        React.createElement("path", { d: "M1 11.5A2.5 2.5 0 0 0 3.5 14H5a.5.5 0 0 0 0-1H3.5A1.5 1.5 0 0 1 2 11.5V10a.5.5 0 0 0-1 0v1.5Z" }),
        React.createElement("path", { d: "M14 11.5a2.5 2.5 0 0 1-2.5 2.5H10a.5.5 0 0 1 0-1h1.5a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 1 1 0v1.5Z" }),
        React.createElement("path", { d: "M1 3.5A2.5 2.5 0 0 1 3.5 1H5a.5.5 0 0 1 0 1H3.5A1.5 1.5 0 0 0 2 3.5V5a.5.5 0 0 1-1 0V3.5Z" }),
        React.createElement("path", { d: "M8 4.5a.5.5 0 0 0-1 0V7H4.5a.5.5 0 0 0 0 1H7v2.5a.5.5 0 0 0 1 0V8h2.5a.5.5 0 0 0 0-1H8V4.5Z" })));
});
